import React, {useEffect, useRef, useState} from 'react'
import {IntegrationPageTitle} from '../../../../../_metronic/layout/core/IntegrationPageData'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import db from '../../../../../services/firebase'
import {collection, doc, onSnapshot} from 'firebase/firestore'
import {useAuth} from '../../../../modules/auth'
import {AssetListLoading} from '../loading/AssetListLoading'
import {ToastContainer} from 'react-toastify'
import useCrispChat from 'app/Hooks/useCrispChat'
import {drawerComponentMap, integrationCategories} from '../../config/integrationConfig'
import Searchbar from 'app/components/Searchbar'
import EmptyState from 'app/components/EmptyState'

const IntegrationAvailabe = () => {
  const [modalStates, setModalStates] = useState({
    AWS: false,
    Asana: false,
    GitLab: false,
    Sentry: false,
    GitHub: false,
    Linear: false,
    Bitbucket: false,
    'Github Dependabot': false,
    Jira: false,
    ClickUp: false,
    Shortcut: false,
    Notion: false,
    Slack: false,
    'Aikido Security': false,
    'Google Cloud Platform': false,
  })
  const [integrations, setIntegrations] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredIntegrations, setFilteredIntegrations] = useState<any[]>([])
  const [show, setShow] = useState(false)
  const overlayRef = useRef<HTMLElement>(null)
  const [selectedIntegration, setSelectedIntegration] = useState('')
  const [activeIntegrations, setActiveIntegrations] = useState<any[]>([])
  const {currentUser} = useAuth()
  const [showEmptyState, setShowEmptyState] = useState<boolean>(false)
  const [connectedIntegrations, setConnectedIntegration] = useState<any[]>([])
  const {toggleCrispChat} = useCrispChat()

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const serviceParam = queryParams.get('service')

    if (serviceParam) {
      const initialSearchTerm = serviceParam.toLowerCase()
      setSearchTerm(initialSearchTerm)
      if (serviceParam === 'Linear') {
        integrationHandlers.Linear(true)
      }
    }
  }, [])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowEmptyState(true)
    }, 2000)
    return () => clearTimeout(timeoutId)
  }, [])

  useEffect(() => {
    getIntegrations()
    getActiveIntegrations()
  }, [])

  useEffect(() => {
    setFilteredIntegrations(integrations)
  }, [integrations])

  const getIntegrations = () => {
    try {
      const collectionRef = db.collection('integrations')

      const unsubscribe = collectionRef.onSnapshot((snapshot) => {
        const integrations: any[] = []
        snapshot.forEach((doc) => {
          const data = doc.data()
          integrations.push(data)
        })
        setShowEmptyState(false)
        setIntegrations(integrations)
      })

      return unsubscribe
    } catch (error) {
      setShowEmptyState(false)
    }
  }

  const getActiveIntegrations = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)

      const testsCollectionRef = collection(tenantRef, 'active_integrations')

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const frameworksData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          integrations: doc.data().integrations,
        }))
        const integrations = frameworksData[0]?.integrations || []
        setActiveIntegrations(integrations)
        setShowEmptyState(false)
      })

      return unsubscribe
    } catch (error) {
      setShowEmptyState(false)
    }
  }

  useEffect(() => {
    getConnectedIntegration()
  }, [])

  useEffect(() => {
    let filteredItems = integrations

    if (selectedIntegration) {
      filteredItems = filteredItems.filter((item) => item.group === selectedIntegration)
    }

    if (searchTerm) {
      filteredItems = filteredItems.filter((item) => item.name.toLowerCase().includes(searchTerm))
    }

    setFilteredIntegrations(filteredItems)
  }, [searchTerm, integrations, selectedIntegration])

  const getConnectedIntegration = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const PolicyRef = collection(tenantRef, 'integrations')

      const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
        const integrationData = snapshot.docs.map((item) => ({
          ...item.data(),
          id: item.id,
          name: item.data().name,
        }))
        setConnectedIntegration(integrationData)
        setShowEmptyState(false)
      })

      return unsubscribe
    } catch (error) {
      setShowEmptyState(false)
    }
  }

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target as Node) && show) {
        setShow(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [show])

  const handleModal = (integrationName: string, isOpen: boolean) => {
    setModalStates((prev) => ({
      ...prev,
      [integrationName]: isOpen,
    }))
  }
 

  const integrationHandlers = {
    AWS: (isOpen: boolean) => handleModal('AWS', isOpen),
    Asana: (isOpen: boolean) => handleModal('Asana', isOpen),
    GitLab: (isOpen: boolean) => handleModal('GitLab', isOpen),
    Sentry: (isOpen: boolean) => handleModal('Sentry', isOpen),
    Github: (isOpen: boolean) => handleModal('Github', isOpen),
    Linear: (isOpen: boolean) => handleModal('Linear', isOpen),
    Bitbucket: (isOpen: boolean) => handleModal('Bitbucket', isOpen),
    'Github Dependabot': (isOpen: boolean) => handleModal('Github Dependabot', isOpen),
    Jira: (isOpen: boolean) => handleModal('Jira', isOpen),
    ClickUp: (isOpen: boolean) => handleModal('ClickUp', isOpen),
    Shortcut: (isOpen: boolean) => handleModal('Shortcut', isOpen),
    Notion: (isOpen: boolean) => handleModal('Notion', isOpen),
    Slack: (isOpen: boolean) => handleModal('Slack', isOpen),
    'Aikido Security': (isOpen: boolean) => handleModal('Aikido Security', isOpen),
    'Google Cloud Platform': (isOpen: boolean) => handleModal('Google Cloud Platform', isOpen),
  }

  const renderDrawers = () => {
    return Object.entries(modalStates).map(([name, isOpen]) => {
      const DrawerComponent = drawerComponentMap[name]
      if (DrawerComponent) {
        return (
          <DrawerComponent key={name} isOpen={isOpen} onClose={() => handleModal(name, false)} />
        )
      }
      return null
    })
  }

  return (
    <>
      <ToastContainer />
      <IntegrationPageTitle
        icon='integrations.svg'
        title='Integrations'
        desc='Connect services and activate automated evidence collection & monitoring.'
      >
        Integrations
      </IntegrationPageTitle>
      <div className='card-title mb-4'>
        <div
          className='d-flex justify-content-between align-items-center'
          data-kt-user-table-toolbar='base'
        >
          <div className='flex-lg-fill'>
            <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>

          <div className='d-flex justify-content-between align-items-center mb-4'>
            <label htmlFor='Integrations' className='fw-semibold fs-6 me-2'>
              Category
            </label>
            <select
              id='Integrations'
              className='form-select form-control w-auto'
              aria-label='Select Integrations'
              value={selectedIntegration}
              onChange={(e) => {
                setSelectedIntegration(e.target.value)
                const value = e.target.value

                if (value) {
                  const filteredItems = integrations.filter((item) => item.group === value)
                  setFilteredIntegrations(filteredItems)
                } else {
                  setFilteredIntegrations(integrations)
                }
              }}
            >
              {integrationCategories.map((category) => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {renderDrawers()}
      {(() => {
        const groups = filteredIntegrations.reduce((acc: string[], item) => {
          if (!acc.includes(item.group)) {
            acc.push(item.group)
          }
          return acc
        }, [])

        return groups.map((group: any) => (
          <div key={group}>
            <h4 className='mb-4 mt-8'>{group}</h4>
            {filteredIntegrations
              .filter((item) => item.group === group)
              .map((item, index) => (
                <div key={`${group}-${index}`} className={`card mb-5 mb-xl-8`}>
                  <div className='card-header border-0 pt-5 mb-5'>
                    <div className='d-flex align-items-center'>
                      <div
                        className='d-inline-block position-relative me-5'
                        style={{
                          width: '45px',
                          height: '45px',
                          overflow: 'hidden',
                          backgroundColor: '#F6F6F6',
                          borderRadius: '10px',
                          padding: '6px',
                        }}
                      >
                        <img
                          src={toAbsoluteUrl(`${item.img_path}`)}
                          alt=''
                          loading='lazy'
                          style={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      </div>

                      <div className='d-flex justify-content-start flex-column'>
                        <span className='card-label fw-bold fs-5'>{item.name}</span>
                        <span className='fw-semibold fs-6' style={{color: '#5A5A5A'}}>
                          {item.description}
                        </span>
                      </div>
                    </div>
                    {activeIntegrations.includes(item.name) &&
                    connectedIntegrations.some((ci) => ci.name === item.name) ? (
                      <button
                        onClick={() =>
                          integrationHandlers[item.name]
                            ? integrationHandlers[item.name](true)
                            : handleModal(item.name, true)
                        }
                        className='btn btn-sm fs-6 mt-2'
                        onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                          (e.currentTarget.style.backgroundColor = '#148363')
                        }
                        onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                          (e.currentTarget.style.backgroundColor = '#0E9F6E')
                        }
                        style={{
                          backgroundColor: '#6c757d',
                          color: '#fff',
                          height: '40px',
                          borderRadius: '4px',
                          left: '615px',
                          top: '20px',
                          transition: 'background-color 0.3s',
                        }}
                        disabled
                      >
                        Added
                      </button>
                    ) : activeIntegrations.includes(item.name) ? (
                      <button
                        onClick={() =>
                          integrationHandlers[item.name]
                            ? integrationHandlers[item.name](true)
                            : handleModal(item.name, true)
                        }
                        className='btn btn-sm fs-6 mt-2'
                        style={{backgroundColor: '#0E9F6E', color: '#FFFFFF', height: '40px'}}
                        onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                          (e.currentTarget.style.backgroundColor = '#148363')
                        }
                        onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                          (e.currentTarget.style.backgroundColor = '#0E9F6E')
                        }
                      >
                        Connect
                      </button>
                    ) : (
                      <button
                        onClick={() => toggleCrispChat()}
                        className='btn btn-sm fs-6 mt-2'
                        onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                          (e.currentTarget.style.backgroundColor = '#148363')
                        }
                        onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                          (e.currentTarget.style.backgroundColor = '#0E9F6E')
                        }
                        style={{
                          backgroundColor: '#0E9F6E',
                          color: '#fff',
                          height: '40px',
                          borderRadius: '4px',
                          left: '615px',
                          top: '20px',
                          transition: 'background-color 0.3s',
                        }}
                      >
                        Request
                      </button>
                    )}
                  </div>
                </div>
              ))}
          </div>
        ))
      })()}

      {filteredIntegrations.length === 0 && showEmptyState && (
        <EmptyState
          title='No Integrations Found'
          description="We couldn't find any integrations that match your search or filter. Try a different search or category."
        />
      )}

      {showEmptyState && activeIntegrations.length === 0 && (
        <div
          className='d-flex justify-content-center align-items-center text-center'
          style={{height: '500px'}}
        >
          <AssetListLoading />
        </div>
      )}
    </>
  )
}

export default IntegrationAvailabe
